import { useQuery } from '@tanstack/react-query'
import { hasLiveApi } from '@/api/client'
import { fixtureSubGames, getSubGames } from '@/api/map/game'
import { isUnreachableApiError } from '@/api/unreachable'
import { keys } from '@/api/hooks/shared/keys'

async function loadSubGames(game: string): Promise<string[]> {
  if (!hasLiveApi()) return fixtureSubGames(game)
  try {
    return await getSubGames(game)
  } catch (error) {
    if (isUnreachableApiError(error)) return []
    throw error
  }
}

/**
 * Lab `Account/getSubGames` — sport / table names for the selected product.
 *
 * `game` is the Lab Mongo id from Game/getGames, or `all` (SportsBook default).
 */
export function useSubGames(game: string | null) {
  const gameKey = game && game !== 'all' ? game : 'all'
  return useQuery({
    queryKey: keys.subGames(gameKey),
    queryFn: () => loadSubGames(gameKey),
    staleTime: 60_000,
  })
}
